<template>
    <AxiosOverlayer :loading="axiosCall"/>
</template>

<script>
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {computed, ref} from "vue";
import {API} from "@/utils/api";

export default {
    name: "Loading",
    setup(){
        const route = useRoute();
        const store = useStore();
        const router = useRouter();
        const loggedIn = computed(() => store.getters['Customer/isLoggedIn'])
        const axiosCall = ref(false);

        if(loggedIn.value) {
            (async ()  =>{
                axiosCall.value = true;
                await API.post('getProjectByHash', {hash: route.params.hash}).then((resp) => {
                    axiosCall.value = false;
                    const projectData = resp.data.project;
                    store.dispatch('Calculator/setGeneralData', projectData['generalData']);

                    if(resp.data.id){
                        router.push('/form/edit/' + resp.data.id);
                    } else {
                        router.push('/form');
                    }

                    console.log('projectData',projectData)
                }).catch(err => {
                    axiosCall.value = false
                    console.error(err);

                })

            })()
        } else {
            router.push('/login?redirect=/laden/'+encodeURIComponent(route.params.hash));
        }

        return{
            axiosCall
        }

    }
}
</script>

<style scoped>

</style>
